import { Action, Dispatch } from 'redux'
import { initStoreShippingsAction } from 'reducks/storeShipping/actions'

const initStoreShippings = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(initStoreShippingsAction())
  }
}

export default initStoreShippings
